<template>
  <div class="positionRel m-t-md">
    <gmap-autocomplete v-if="inputSearch" class="autocomplete" :placeholder="'search google maps'"
      @place_changed="setPlace">
    </gmap-autocomplete>
    <gmap-map
      :center="center"
      :zoom="14"
      :clickable="true"
      :draggable="true"
      :options="options"
      style="width:100%; height: 300px;"
      ref="mapRef"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center = changeMarker ? m.position : center"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
  export default {
    name: "GoogleMap",
    props: {
      location: String | Object,
      inputSearch: Boolean,
      changeMarker: Boolean,
    },
    data() {
      return {
        center: { lat: 3.135, lng: 101.69 },  // Kuala Lumpur, Malaysia
        map: null,
        infoWindow: null,
        marker: null,
        markers: [],
        places: [],
        styles: [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#d0d0d0"},{"lightness":-25},{"saturation":-97}]}],
        options: {
          // zoomControl: false,
          mapTypeControl: false,
          // scaleControl: false,
          // streetViewControl: false,
          // rotateControl: false,
          // fullscreenControl: false,
          // disableDefaultUi: false
        },
        currentPlace: null,
        mapRef: null
      };
    },

    mounted() {
      var marker = null;
      this.$refs.mapRef.$mapPromise.then(map => {
        this.map = map;
        let that = this;

        google.maps.event.addListener(map, 'click', function(event) {
          if(!this.changeMarker || !marker) return;
          let pos = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };
          that.addMarker(pos, google, map);
        });

        let styledMap = new google.maps.StyledMapType(this.styles, { name : "Styled Map" });
        map.mapTypes.set('map_style', styledMap);
        map.setMapTypeId('map_style');

        this.geolocate(google, map);

      });
    },

    methods: {
      setPlace(place) {
        console.log('setPlace');
        if(!place) return;
        if(place.geometry){
          this.currentPlace = place;
          this.center = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };
          this.setMarker(this.center);
        }
        else if(place.name) {
          let that = this;
          let service = new google.maps.places.PlacesService(this.map);

          var request = {
            query: place.name,
            fields: ['name', 'geometry'],
          };

          service.findPlaceFromQuery(request, function(results, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              that.setMarker(results[0].geometry.location);
            }
          });
        }

      },
      addMarker(marker, google = null, map = null) {
        this.currentPlace = null;
        this.$emit('get-marker', {marker});

        if(this.marker){
          this.marker.setMap(null);
        }
        this.marker = new google.maps.Marker({
          position: marker,
          map: map,
          title: `Latitude: ${marker.lat}\nLongitude: ${marker.lng}`
        });

        if (this.infoWindow) {
          this.infoWindow.close();
        }
        this.infoWindow = new google.maps.InfoWindow;
        this.infoWindow.setPosition(marker);
        this.infoWindow.setContent(`Latitude: ${marker.lat}<br> Longitude: ${marker.lng}`);
        this.infoWindow.open(map, this.marker);
      },
      setMarker(marker) {
        if(!this.changeMarker || !marker) return;
        this.markers = [{ position: marker }];
        this.center = marker;
        this.currentPlace = null;
        this.$emit('get-marker', {marker});
      },
      geolocate: function(google = null, map = null) {
        if(this.location && this.location.lat && this.location.lng) {
          this.center = this.location;
          let marker = {
            lat: this.location.lat,
            lng: this.location.lng
          };
          this.addMarker(marker, google, map);
        }
        /*navigator.geolocation.getCurrentPosition(position => {
          if(!position) return;
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });*/

      }
    },
    watch: {
      location: function (to) {
        this.geolocate(google, this.map);
      },
    }
  };
</script>

<style scoped>
  .autocomplete{
    position: absolute;
    top: 10px;
    z-index: 9;
    left: 10px;
    overflow: hidden;
    height: 40px;
    display: table-cell;
    vertical-align: middle;
    color: rgb(86, 86, 86);
    font-family: Roboto, Arial, sans-serif;
    font-size: 18px;
    background-color: rgb(255, 255, 255);
    padding: 0px 17px;
    border-radius: 2px;
    border: none;
    background-clip: padding-box;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    min-width: calc(100% - 20px);
  }
  .autocomplete:focus {
    border: 1px solid #0a0a0a;
  }
  .positionRel {
    position: relative;
  }
  @media only screen and (max-width: 767px) {
    .autocomplete {
      padding: 0px 10px;
    }
    .positionRel input {
      max-width: 200px;
    }
  }
</style>
